module.exports = __webpack_public_path__ + "img/shuibeng.4edf5845.png";